import React, { useEffect } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import '../assets/styles/dark.scss';
import '../assets/styles/light.scss';
import AppRoutes from './AppRoutes';
import Navbar from './shared/Navbar';
import Sidebar from './shared/Sidebar';
import AdminSidebar from './shared/AdminSidebar';
import Footer from './shared/Footer';
import { useSelector } from 'react-redux';

const fullPageLayoutRoutes = ['/', '/login', '/logout', '/authentication', '/401', '/403', '/404', '/500'];
const loggedOutRoutes = ['/', '/login', '/authentication'];

function App(props) {
  
  const jwt = useSelector((state) => state.user.jwt);
  const { pathname } = props.location;
  const isFullPageLayout = fullPageLayoutRoutes.includes(pathname);

  let navbarComponent = !isFullPageLayout ? <Navbar /> : '';
  // The sidebar of the enrollments list holds its filters: /admin has its own.
  let sidebarComponent = isFullPageLayout ? '' : ((pathname === '/admin') ? <AdminSidebar /> : <Sidebar />);
  let footerComponent = !isFullPageLayout ? <Footer /> : '';
  
  const history = useHistory(); // Get the history object to programmatically navigate

  useEffect(() => {
    window.scrollTo(0, 0);
    document.querySelector('.page-body-wrapper').classList.toggle('full-page-wrapper', isFullPageLayout);
  }, [pathname, isFullPageLayout]);

  // replace, not push: the /authentication?token= entry leaves the history, so the token does not stay in it.
  useEffect(() => {
    if ((jwt !== null) && loggedOutRoutes.includes(pathname))
      history.replace('/enrollments');
    else if ((jwt === null) && !fullPageLayoutRoutes.includes(pathname))
      history.push('/');
  }, [history, jwt, pathname]);

  return (
    <div className="container-scroller">
      { sidebarComponent }
      <div className="container-fluid page-body-wrapper">
        { navbarComponent }
        <AppRoutes/>
        { footerComponent }
        </div>
    </div>
  );

}

export default withRouter(App);
